import { SHOP_LOCALES } from 'commerce/scayle/constants';

export const minLength = {
  zip: {
    [SHOP_LOCALES.DE]: 5,
    [SHOP_LOCALES.AT]: 4,
  },
  dhl: 6,
};

export const maxLength = {
  email: 50,
  dhl: 10,
};
